import React, {Component} from 'react';
import Axios from 'axios';

const closeIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/close-icon.png";

class AccessChangeNotification extends Component {
    constructor(props) {
      super(props)
      this.state = {

      }

      this.clearAccessChangeNotification = this.clearAccessChangeNotification.bind(this)

    }

    componentDidMount() {
      console.log('componentDidMount called in SubAccessChangeNotification', this.props)

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');

      // notify the user, then save that the user has been notified in the backend

      let modalTitle = ''
      let modalDescription = ''
      let accessType = ''

      if (this.props.accessChangeNotification) {
        const codeArray = this.props.accessChangeNotification.split("|")
        if (codeArray[0] === 'member_archived') {
          modalTitle = 'Your community access has changed'
          modalDescription = 'Your access to the ' + codeArray[2] + ' community is no longer active, so you’ve been moved to the general Guided Compass community. Your Guided Compass account has not been deleted. If you believe this was a mistake, please contact the ' + codeArray[2] + ' program administrator.'
        } else if (codeArray[0] === 'member_restored') {
          modalTitle = 'Your community access has been restored'
          modalDescription = 'Your access to the ' + codeArray[2] + ' community have been re-activated. Previously you were removed, but you have now been re-added to the ' + codeArray[2] + ' community.'
        } else if (codeArray[0] === 'role_changed') {
          modalTitle = 'Your role has changed'
          modalDescription = 'Your role type has been changed to a ' + roleName + ' by a ' + codeArray[2] + ' admin. This means you have access to a different portal which includes different functionality. If this was a mistake, please contact the ' + codeArray[2] + ' program administrator.'
        }

        this.setState({ modalTitle, modalDescription })

        // update accessChangeNotification
        this.clearAccessChangeNotification(email)
      }
    }

    clearAccessChangeNotification(email) {
      console.log('clearAccessChangeNotification called', email)

      Axios.post('/api/users/access-change-notification/clear', { email })
      .then((response) => {
        if (response.data.success) {
          console.log('Clear worked', response.data);

          localStorage.removeItem('accessChangeNotification')

        } else {
          console.error('there was an error clearing notifications');
        }
      }).catch((error) => {
          console.log('Clearing notification did not work', error);
      });

    }

    render() {

      return (
          <div>
            <div>
              <div>
                <div className="calc-column-offset-40">
                  <p className="heading-text-2">{this.state.modalTitle}</p>
                </div>
                <div className="fixed-column-40 top-margin">
                  <button className="background-button" onClick={() => this.props.closeModal()}>
                    <img src={closeIcon} alt="GC" className="image-auto-20" />
                  </button>
                </div>
                <div className="clear" />
              </div>

              <div className="spacer" />

              <div className="row-40">
                <p>{this.state.modalDescription}</p>
              </div>

              <div className="spacer"/>

              <button className="btn btn-primary" onClick={() => this.props.closeModal()}>Continue</button>
            </div>
          </div>

      )
    }
}

export default AccessChangeNotification;
